/** @jsx jsx */

import React, { useContext, useRef, useEffect } from 'react';
import { css as _css } from 'emotion';
import { css, jsx } from '@emotion/core';
import getTopics from 'services/apiHelpers/getTopics';
import TopicPanel from './TopicPanel';
import { interactionContext } from './interactionContext';
import { unlockInteraction } from 'services/unlockInteraction';
import getInteractionsInTopic from 'services/apiHelpers/getInteractionsInTopic';
import { updateTopicPortalMedia } from './updateTopicPortalMedia';

type Timeout = ReturnType<typeof setTimeout>;

const TopicPortalContainer = props => {
  const context = useContext(interactionContext);
  const {
    selectedTopics = [],
    hideTopicsThatIncludeATopicPortal = true,
  } = context?.props;
  //

  const { children } = props;

  const topics = getTopics();

  const displayedTopics = topics.filter((t: any, index: number) => {
    const topicIncludesPortal = getInteractionsInTopic(t).find(i => {
      return i?.meta?.subType === 'TopicPortal';
    });

    if (selectedTopics.length) {
      return (
        selectedTopics.includes(t?.props?.sId) || selectedTopics.includes(t.id)
      );
    }

    return (
      !(hideTopicsThatIncludeATopicPortal && topicIncludesPortal) &&
      t.props.hiddenFromPortal !== true
    );
  });

  // window.dev() &&
  //   console.log(
  //     'portal will unlock when these topics ( updated to reference the sId ) are complete :',
  //     displayedTopics.map(t => {
  //       return `${t?.props?.sId} || ${t?.id} ${t?.props?.name}`;
  //     })
  //   );

  const { lockDown } = context.props;

  const delayTopicChildrenLengthCheck = useRef<Timeout | undefined>();

  const itemsSeen = useRef(
    unlockInteraction(context.id, (displayedTopics as any).length)
  );

  const { addMedia, removeMedia } = updateTopicPortalMedia(topics, context.id);

  const updateTopicComplete = id => {
    itemsSeen.current(id);
  };

  useEffect(() => {
    if (!window.dev()) {
      return;
    }

    console.log('if these are out of sync. we do the thing. add / remove', {
      'topics.length': topics.length,
      'children.length': children.length,
    });

    // the intent here is to. . .
    // maybe there's a chance that as the blocks settle into place topic.length and children.length
    // would be out of sync on initial load ?
    // this ' should ' not happen. ' should ' not. but. . .
    //
    clearTimeout(delayTopicChildrenLengthCheck.current as Timeout);
    //
    delayTopicChildrenLengthCheck.current = setTimeout(() => {
      //
      console.log(
        'running topic.length children.length comparison after 300ms delay'
      );

      if (topics.length > children.length) {
        addMedia();
        return;
      }

      if (topics.length < children.length) {
        removeMedia();
      }
    }, 300);

    return () => {};
  }, [topics.length]);
  //

  return (
    <div
      css={css`
        width: 100%;
      `}
    >
      <div
        className="fader_-5s"
        css={css`
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          margin: 12px 0 12px 0;
        `}
      >
        {displayedTopics.map((t: any, index: number) => {
          const topicMedia = children.find(media => {
            // in ye olden times we were checking for an id match. now we're comparing to sId
            return media?.props?.topicSId === t?.props?.sId;
          });

          if (window.dev() && topicMedia) {
            //
            console.log(t?.id, t?.props?.sId, topicMedia?.props);
          }

          return (
            <TopicPanel
              key={t.id}
              topic={t}
              updateTopicComplete={updateTopicComplete}
              displayedTopics={displayedTopics}
            >
              {topicMedia ? topicMedia.props.children : null}
            </TopicPanel>
          );
        })}
      </div>
    </div>
  );
};

export default TopicPortalContainer;
